import {timezoneSafeTimestamp} from '../core/time.js';
// Pure duration arithmetic. Product kinds, warnings and labels stay in adapters.
export function scheduleBackwardChain(blocks,endAt,{lane,itemId=null}={}){
  if(!Array.isArray(blocks))throw new TypeError('blocks must be an array');
  let cursor=endAt==null?null:Date.parse(timezoneSafeTimestamp(endAt,'endAt'));
  const scheduled=[];
  for(let index=blocks.length-1;index>=0;index-=1){
    const block=blocks[index],missing=block.durationKind==='missing';
    const minutes=block.durationMinutes;
    if(missing&&minutes!=null)throw new TypeError('Missing duration cannot carry durationMinutes');
    if(!missing&&(!Number.isInteger(minutes)||minutes<1))throw new TypeError('durationMinutes must be a positive integer');
    const end=cursor;
    const start=missing||end==null?null:end-minutes*60_000;
    scheduled.push(Object.freeze({...block,startAt:start==null?null:new Date(start).toISOString(),endAt:end==null?null:new Date(end).toISOString(),lane,itemId:itemId??block.itemId}));
    cursor=start;
  }
  return Object.freeze({blocks:Object.freeze(scheduled.reverse()),startMillis:cursor});
}
